import { z } from 'zod';

import { emailSchema, passwordSchema } from './auth-schemas.js';
import { staffRoleSchema } from './roles.js';

export const userNameSchema = z.string().trim().min(1, 'Name is required').max(120);

export const inviteUserInput = z.object({
  email: emailSchema,
  name: userNameSchema,
  role: staffRoleSchema,
});
export type InviteUserInput = z.infer<typeof inviteUserInput>;

export const updateRoleInput = z
  .object({
    role: staffRoleSchema.optional(),
    tabletMode: z.boolean().optional(),
  })
  .refine((v) => v.role !== undefined || v.tabletMode !== undefined, {
    message: 'Provide role and/or tabletMode',
  });
export type UpdateRoleInput = z.infer<typeof updateRoleInput>;

export const profileUpdateInput = z
  .object({
    name: userNameSchema.optional(),
    email: emailSchema.optional(),
  })
  .refine((v) => v.name !== undefined || v.email !== undefined, {
    message: 'Provide at least one field to update',
  });
export type ProfileUpdateInput = z.infer<typeof profileUpdateInput>;

export const passwordChangeInput = z.object({
  currentPassword: z.string().min(1, 'Current password is required'),
  newPassword: passwordSchema,
});
export type PasswordChangeInput = z.infer<typeof passwordChangeInput>;
